// extracted by mini-css-extract-plugin
module.exports = {"parentEditModal":"parentLogin_parentEditModal__d3vF9"};